val configFile = ConfigFile(
    shouldShowScrollBar = true
)

actual fun getClientConfig(): ConfigFile {
    return configFile}